import { render, staticRenderFns } from "./WhList.vue?vue&type=template&id=68aa86f4&scoped=true"
import script from "./WhList.vue?vue&type=script&lang=js"
export * from "./WhList.vue?vue&type=script&lang=js"
import style0 from "./WhList.vue?vue&type=style&index=0&id=68aa86f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa86f4",
  null
  
)

export default component.exports